import { Map } from 'immutable';

import * as t from '../../actions/friendProfileActionType';

const initialState = Map({
  friendProfile: {
    private: false,
  },
});

const reducer = function friendProfileReducer(state = initialState, action) {
  switch (action.type) {
    case t.SET_FRIEND_PROFILE:
      return state.set('friendProfile', action.friendProfile);
    default:
      return state;
  }
};

export default reducer;
